require("trix")
require("@rails/actiontext")
require("packs/richtext")
import Tags from 'bootstrap5-tags'

  if(document.querySelectorAll(".user_trix_editor") != null && !window.location.href.includes("learn-web3")) {
    document.querySelectorAll(".trix-button-group--file-tools").forEach(el => el.remove());
    document.querySelectorAll(".trix-button--icon-heading-1").forEach(el => el.remove());
    document.querySelectorAll(".trix-button--icon-link").forEach(el => el.remove());
    document.addEventListener("trix-file-accept", function(event) {
      event.preventDefault();
    });
  }